var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTextLiveOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4122 5.28723C21.0203 7.06183 22 9.41649 22 12C22 14.5834 21.0203 16.9381 19.4122 18.7127M4.5878 18.7127C2.97968 16.9381 2 14.5834 2 12C2 9.41649 2.97968 7.06183 4.5878 5.28723",
    stroke: "#023F80",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5851 8.12976C17.4679 9.17452 18 10.5251 18 11.9999C18 13.4748 17.4679 14.8254 16.5851 15.8701M7.41489 15.8701C6.53214 14.8254 6 13.4748 6 11.9999C6 10.5251 6.53214 9.17452 7.41489 8.12976",
    stroke: "#023F80",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 14.5V10",
    stroke: "#023F80",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 10H14",
    stroke: "#023F80",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25468 5.89162C5.58845 5.52329 5.56044 4.95413 5.19212 4.62037C4.82379 4.2866 4.25463 4.31461 3.92086 4.68293C2.1686 6.6166 1.09998 9.18456 1.09998 12C1.09998 14.8155 2.1686 17.3834 3.92086 19.3171C4.25463 19.6854 4.82379 19.7134 5.19212 19.3796C5.56044 19.0459 5.58845 18.4767 5.25468 18.1084C3.79071 16.4929 2.89998 14.3515 2.89998 12C2.89998 9.64851 3.79071 7.50715 5.25468 5.89162Z",
    fill: "#023F80"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0791 4.68293C19.7453 4.31461 19.1762 4.2866 18.8078 4.62037C18.4395 4.95413 18.4115 5.52329 18.7453 5.89162C20.2092 7.50715 21.1 9.64851 21.1 12C21.1 14.3515 20.2092 16.4929 18.7453 18.1084C18.4115 18.4767 18.4395 19.0459 18.8078 19.3796C19.1762 19.7134 19.7453 19.6854 20.0791 19.3171C21.8314 17.3834 22.9 14.8155 22.9 12C22.9 9.18456 21.8314 6.6166 20.0791 4.68293Z",
    fill: "#023F80"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.10233 8.71068C8.42313 8.331 8.3754 7.76316 7.99572 7.44236C7.61605 7.12156 7.0482 7.16928 6.7274 7.54896C5.71256 8.75005 5.09998 10.3047 5.09998 12C5.09998 13.6953 5.71256 15.25 6.7274 16.451C7.0482 16.8307 7.61605 16.8784 7.99572 16.5576C8.3754 16.2368 8.42313 15.669 8.10233 15.2893C7.35167 14.4009 6.89998 13.2544 6.89998 12C6.89998 10.7456 7.35167 9.5991 8.10233 8.71068Z",
    fill: "#023F80"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2725 7.54896C16.9517 7.16928 16.3839 7.12156 16.0042 7.44236C15.6246 7.76316 15.5768 8.331 15.8976 8.71068C16.6483 9.5991 17.1 10.7456 17.1 12C17.1 13.2544 16.6483 14.4009 15.8976 15.2893C15.5768 15.669 15.6246 16.2368 16.0042 16.5576C16.3839 16.8784 16.9517 16.8307 17.2725 16.451C18.2874 15.25 18.9 13.6953 18.9 12C18.9 10.3047 18.2874 8.75005 17.2725 7.54896Z",
    fill: "#023F80"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9 10.9H14C14.497 10.9 14.9 10.4971 14.9 10C14.9 9.50295 14.497 9.10001 14 9.10001H9.99998C9.50292 9.10001 9.09998 9.50295 9.09998 10C9.09998 10.4971 9.50292 10.9 9.99998 10.9H11.1V14.5C11.1 14.9971 11.5029 15.4 12 15.4C12.497 15.4 12.9 14.9971 12.9 14.5V10.9Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextLiveOutline);
export default __webpack_public_path__ + "static/media/text_live_outline.b09ceaae35ca8815a5a0c86e6a1bc47e.svg";
export { ForwardRef as ReactComponent };